import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAppSelector, useAppDispatch } from '@app/store/hooks';
import { endpoints } from '@app/api/apis';
import { updateIsNotFirstDisbursal } from '@app/store/slices/authSlice';

const useDisbursalDetails = () => {
  const dispatch = useAppDispatch();
  const creditId = useAppSelector((state) => state.auth.userDetails?.linkedCredits[0]?.creditId);
  const isNotFirstDisbursal = useAppSelector((state) => state.auth.isNotFirstDisbursal);
  const [isLoading, setIsLoading] = useState(false);

  const fetchDisbursalDetails = async () => {
    if (!creditId) return;
    
    setIsLoading(true);
    try {
      const url = endpoints.disbursalDetails + creditId;
      const res = await axios.get(url);
      dispatch(updateIsNotFirstDisbursal({isNotFirstDisbursal: res?.data?.length > 0}));
    } catch (err) {
      console.log('fetchDisbursalDetails', err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (creditId && isNotFirstDisbursal === false) {
      fetchDisbursalDetails();
    }
  }, [creditId]);

  return {
    isNotFirstDisbursal,
    isLoading,
  };
};

export default useDisbursalDetails;